import { CircleOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import { CES_STATUS_TO_TASK_STATUS } from '@/lib/compliance-status'
import {
  configForColumn,
  configForStatus,
} from '@/pages/tasks/taskColumns.config'
import type { TaskColumnId } from '@/pages/tasks/types'

const STATUS_ICON_CLASS: Record<TaskColumnId, string> = {
  backlog: 'text-muted-foreground',
  todo: 'text-text-body',
  in_progress: 'text-status-orange-strong',
  blocked: 'text-status-red-strong',
  in_review: 'text-status-green',
  done: 'text-status-blue-text',
}

type TaskStatusIconProps = {
  status?: string
  columnId?: TaskColumnId
  className?: string
}

export function TaskStatusIcon({
  status,
  columnId,
  className,
}: TaskStatusIconProps) {
  // Not-applicable tests get a distinct icon instead of collapsing into the
  // blue "Done" check (NOT_APPLICABLE → DISMISSED → done column otherwise).
  if (status === 'NOT_APPLICABLE') {
    return (
      <CircleOff
        className={cn('h-4 w-4 shrink-0 text-text-placeholder', className)}
      />
    )
  }

  const normalizedStatus = status
    ? (CES_STATUS_TO_TASK_STATUS[status as keyof typeof CES_STATUS_TO_TASK_STATUS] ?? status)
    : ''
  const config = columnId
    ? configForColumn(columnId)
    : configForStatus(normalizedStatus)
  const Icon = config.icon

  return (
    <Icon
      className={cn(
        'h-4 w-4 shrink-0',
        STATUS_ICON_CLASS[config.id],
        className
      )}
    />
  )
}
